<template>
	<div>
		<button
			type="button"
			v-show="telacheia"
			@click="clickTelaCheia"
			style="margin-top: -52px; margin-right: -5px"
			class="btn btn-sm btn-mapa-google pull-right"
		>
			<span class="icon-expandir" style="float: left; margin-top: 2px; margin-right: 4px; font-size: 10px"></span>
			{{ _traducao('global', 'telaCheia') }}
		</button>

		<button
			type="button"
			v-show="!telacheia"
			@click="clickSairTelaCheia"
			style="margin-top: -52px; margin-right: -5px"
			class="btn btn-sm btn-mapa-google pull-right"
		>
			<span class="icon-encolher" style="float: left; margin-top: 2px; margin-right: 4px; font-size: 11px"></span>
			{{ _traducao('global', 'sairTelaCheia') }}
		</button>

		<div>
			<div class="row" style="margin-top: 8px">
				<div class="col-xs-12">
					<h3>
						<i :class="'icon ' + icon" style="margin-top: -1px; float: left; margin-right: 7px; color: #1976d2"></i>
						{{ titulo }}
						<small style="font-weight: 300 !important">{{ subtitulo }}</small>
					</h3>
				</div>
			</div>
		</div>

		<div class="row border">
			<div class="col-xs-12" style="margin-top: 8px; margin-bottom: 8px">
				<a
					href="#"
					v-for="(item, index) in aeronaves"
					:key="index"
					@click.prevent="clickExibeAeronave(index, item)"
					:class="{ativa: item.selecionada}"
					class="btn btn-xs btn-default"
					style="margin-right: 12px; display: -ms-inline-grid"
				>
					<div>
						<div class="row">
							<div class="col-md-12 text-center">
								<a href="#" @click.stop.prevent="clickExibeTodas" class="btn-fechar-aero" v-show="item.selecionada">
									<i class="fa fa-times c-ternaria"></i>
								</a>
								<span style="font-weight: 700" v-html="item.codinome"></span>
							</div>
						</div>

						<hr style="margin-top: 3px; margin-bottom: 3px" />

						<div class="row text-center">
							<div class="col-xs-12">
								<span style="font-weight: 700" v-html="item.prefixo"></span>
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['name', 'icon', 'titulo', 'subtitulo', 'url'],

	data() {
		return {
			aeronaves: [],
			telacheia: true
		}
	},

	mounted() {
		this.getAeronave()
	},

	methods: {
		// retorna a lista de aeronaves
		getAeronave() {
			this._httpGet(this.url, (retorno) => {
				if (retorno._request && retorno._status) {
					for (var i in retorno.lista) {
						retorno.lista[i].selecionada = false
					}

					this.aeronaves = retorno.lista.map(function (item) {
						// HELITACTICA
						if ($cliente.get('id') == 4) {
							item.codinome = item.modelo
							item.modelo = ''
							item.prefixo = '&nbsp;&nbsp;&nbsp;&nbsp;' + item.prefixo
						}

						return item
					})

					if (this.aeronaves.length > 4) {
						this.aeronaves = this.aeronaves.map(function (item) {
							item.modelo = ''
							item.codinome = '&nbsp;&nbsp;' + item.codinome + '&nbsp;&nbsp;'
							return item
						})
					}
				}
			})
		},

		clickExibeAeronave(index, aero) {
			for (var i in this.aeronaves) {
				this.aeronaves[i].selecionada = false
			}
			this.aeronaves[index].selecionada = true
			this.$emit('exibe-aero', {name: this.name, aero: this.aeronaves[index]})
		},

		// exibe o mapa com todas as aeronaves
		clickExibeTodas() {
			for (var i in this.aeronaves) {
				this.aeronaves[i].selecionada = false
			}

			this.$emit('exibe-todas')
		},

		// exibe tela cheia
		clickTelaCheia() {
			this.marginleft = 0

			this.elTelaCheia = document.documentElement
			var rfs =
				this.elTelaCheia.requestFullScreen ||
				this.elTelaCheia.webkitRequestFullScreen ||
				this.elTelaCheia.mozRequestFullScreen ||
				this.elTelaCheia.msRequestFullscreen

			rfs.call(this.elTelaCheia)
			this.telacheia = false

			bus.$emit('tela-cheia', true)
			this.$emit('tela-cheia')
		},

		// sai da tela cheia
		clickSairTelaCheia() {
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen()
			}

			this.telacheia = true

			bus.$emit('sair-tela-cheia', true)
			this.$emit('sair-tela-cheia')
		}
	}
}
</script>